export default {
  dialog: false,
  notificacionLanzada: {
    titulo: '',
    mensaje: '',
    proximoLanzamiento: ''
  },
  botonesDefault: [{ msj: 'Acuse de recibo', color: 'success' }],
  notificacionesListado: []
}